import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Todo } from 'app/main/calendar-todo/todo.model';

@Injectable({
    providedIn: 'root'
})
export class TodoUpdateService {
    private todoUpdateSubject = new Subject<{ date: string, todos: Todo[] }>();

    todoUpdated$ = this.todoUpdateSubject.asObservable();

    notifyTodoUpdate(date: string, todos: Todo[]): void {
        this.todoUpdateSubject.next({ date, todos });
    }
}